<div class="ds-grid ds-grid--2">
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Basic Modals</h3>
			<p class="ds-example__header-subtitle">Default flows for information, confirmation, and destructive actions</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Confirm Modal'"
					[color]="'success'"
					[size]="'small'"
					(action)="showConfirmModal()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Info Modal'"
					[color]="'info'"
					[size]="'small'"
					(action)="showInfoModal()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Warning Modal'"
					[color]="'warning'"
					[size]="'small'"
					(action)="showWarningModal()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Danger Modal'"
					[color]="'danger'"
					[size]="'small'"
					(action)="showDangerModal()">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Size Variants</h3>
			<p class="ds-example__header-subtitle">Examples covering different modal sizes</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'md' + ' Modal' + ' (Default)'"
					[size]="'small'"
					(action)="showSizeModal('md')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'lg' + ' Modal'"
					[size]="'small'"
					(action)="showSizeModal('lg')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'xl' + ' Modal'"
					[size]="'small'"
					(action)="showSizeModal('xl')">
				</eif-custom-button>
				<eif-custom-button
					[text]="'xxl' + ' Modal'"
					[size]="'small'"
					(action)="showSizeModal('xxl')">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Advanced Variants</h3>
			<p class="ds-example__header-subtitle">Examples covering large content, form layouts, and async action handling</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group">
				<eif-custom-button
					[text]="'Form Modal'"
					[size]="'small'"
					(action)="showFormModal()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'Async Action Modal'"
					[color]="'info'"
					[size]="'small'"
					(action)="showAsyncModal()">
				</eif-custom-button>
			</div>
		</div>
	</div>

	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Modal Control</h3>
			<p class="ds-example__header-subtitle">Utilities for dismissing active instances and validating close flows</p>
		</div>
		<div class="ds-example__content">
			<div class="ds-group design-system-modals__group">
				<eif-custom-button
					[text]="'Dismiss All Modals'"
					[color]="'neutral'"
					[size]="'small'"
					(action)="dismissAllModals()">
				</eif-custom-button>
			</div>
		</div>
	</div>
</div>

<ng-template #formModalTemplate>
	<div class="ds-grid ds-grid--1">
		<eif-custom-input
			[label]="'Full Name'"
			[placeholder]="'Enter your full name'"
			[validationRules]="getValidationRules('fullName')"
			(valueChange)="onFormModalValueChange('fullName', $event)"
			(validationChange)="onFormModalValidationChange('fullName', $event)"
			[fullWidth]="true">
		</eif-custom-input>

		<eif-custom-input
			[label]="'Email Address'"
			[placeholder]="'you@example.com'"
			[type]="'email'"
			[validationRules]="getValidationRules('email')"
			(valueChange)="onFormModalValueChange('email', $event)"
			(validationChange)="onFormModalValidationChange('email', $event)"
			[fullWidth]="true">
		</eif-custom-input>

		<eif-custom-select
			[label]="'Department'"
			[placeholder]="'Select a department'"
			[options]="departmentOptions"
			[validationRules]="getValidationRules('department')"
			(valueChange)="onFormModalValueChange('department', $event)"
			(validationChange)="onFormModalValidationChange('department', $event)"
			[fullWidth]="true">
		</eif-custom-select>

		<eif-custom-checkbox
			[label]="'I accept the Terms and Conditions'"
			[color]="'primary'"
			[checkedValue]="'Accepted'"
			[uncheckedValue]="'Not Accepted'"
			[validationRules]="getValidationRules('acceptTerms')"
			(checkedChange)="onFormModalValueChange('acceptTerms', $event)"
			(validationChange)="onFormModalValidationChange('acceptTerms', $event)"
			[fullWidth]="true">
		</eif-custom-checkbox>
	</div>
</ng-template>
